var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55216_49690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36469 23.0754C5.7231 22.6239 3.32548 23.6136 1.65481 23.947C0.631789 24.1492 0.235269 23.7449 0.45732 22.7394C0.941074 20.4843 1.67331 18.2214 0.806257 15.9768C-2.65404 7.11132 5.58564 -2.00353 14.9964 0.385439C23.3338 2.50664 26.8021 12.8002 21.42 19.3528C17.624 23.968 12.8234 24.5902 7.36469 23.0754ZM13.5768 2.28612C6.13812 1.40403 -0.171824 7.90677 2.76506 15.2863C3.43122 16.9665 3.54753 18.8068 3.10343 20.8309C2.99769 21.3113 3.18009 21.474 3.64534 21.3113C5.60679 20.6313 7.19022 20.5342 8.41679 21.033C12.9186 22.8838 17.9412 20.9647 20.397 17.0426C24.0397 11.191 20.6084 3.12095 13.5768 2.28612Z",
    fill: "#191816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6826 14.5173C14.8986 13.2126 16.2045 13.3071 17.6055 14.7956C17.9915 15.1972 18.0496 15.8037 17.7589 16.2736C14.6872 21.2038 3.03741 12.0049 6.80435 6.67044C7.35419 5.88287 8.5226 5.90387 9.06451 6.68882C10.0029 8.06182 10.0584 9.37445 9.23897 10.6319C9.06451 10.8997 9.05658 11.2357 9.2099 11.5035C9.95271 12.8555 11.1132 13.9214 12.6781 14.6984C13.0561 14.8796 13.3919 14.8245 13.6826 14.5173Z",
    fill: "#191816"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55216_49690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.8bb4d4d0e0bce66a53086988fd0ef04c.svg";
export { ForwardRef as ReactComponent };